import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-[#1A1A1A] text-[#F9F6F0] py-20 md:py-28 z-[2]" id="contact" data-testid="footer-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-10 pb-16 border-b border-[#F9F6F0]/15">
          <div className="col-span-12 md:col-span-7">
            <p className="eyebrow text-[#C5A059] mb-6">Say hello</p>
            <h3 className="font-serif-editorial text-5xl md:text-7xl leading-[0.95] tracking-tight">
              Your <span className="italic text-[#E6C5C0]">next elevation</span><br />begins with a note.
            </h3>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 flex flex-col justify-end gap-6">
            <a href="mailto:hello@theelevatedescape.com" data-testid="footer-email"
               className="group flex items-center justify-between gap-4 py-4 border-b border-[#F9F6F0]/20 hover:border-[#C5A059] transition-colors">
              <span className="flex items-center gap-3">
                <Mail size={16} strokeWidth={1.25} className="text-[#C5A059]" />
                <span className="text-lg">hello@theelevatedescape.com</span>
              </span>
              <span className="eyebrow text-[#F9F6F0]/60 group-hover:text-[#C5A059] transition-colors">Email →</span>
            </a>
            <a href="https://instagram.com/the_elevated_escape" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram"
               className="group flex items-center justify-between gap-4 py-4 border-b border-[#F9F6F0]/20 hover:border-[#C5A059] transition-colors">
              <span className="flex items-center gap-3">
                <Instagram size={16} strokeWidth={1.25} className="text-[#C5A059]" />
                <span className="text-lg">@the_elevated_escape</span>
              </span>
              <span className="eyebrow text-[#F9F6F0]/60 group-hover:text-[#C5A059] transition-colors">Follow →</span>
            </a>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <p className="font-serif-editorial italic text-3xl md:text-4xl">The Elevated Escape</p>
            <p className="eyebrow text-[#F9F6F0]/50 mt-3">VIP status · without the memberships</p>
          </div>
          <div className="text-sm text-[#F9F6F0]/50">
            © {new Date().getFullYear()} The Elevated Escape · All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
